export default     {
    prompt:"Icon Color?",
    type:"childStyle",
    field:"--icon-color",
    child:".main-cont",
    valueType:"string",
    colorPicker:true,
    default:"inherit",
    property:"--icon-color"
}